import { Chip } from '@mui/material'
import React from 'react'
import { string } from 'prop-types'

/**
 * @param {value} string
 * @returns
 */

const ApprovedChip = ({ value = 'ativo' }) => {
  const colors = {
    aprovado: 'success',
    reprovado: 'error',
    ativo: 'success',
    inativo: 'error',
    default: 'default'
  }

  return (
    <Chip
      sx={{ cursor: 'pointer' }}
      color={colors[value.toLowerCase()]}
      label={value}
    />
  )
}
ApprovedChip.propTypes = {
  value: string
}

export default ApprovedChip
